import { Radio, Text } from '@mantine/core';
import { Filter } from './Filters';
import useValidatedSearchParams from '../../../../router/useValidatedSearchParams';
import classes from './Filters.module.css';

const RadioFilter = <T,>({ filter }: { filter: Filter<T> }) => {
  const {
    validatedParams,
    setValidatedParam,
    SEARCH_PARAMS_KEYS: { PLOT_ID },
  } = useValidatedSearchParams();

  const value = validatedParams[filter.key];

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValidatedParam(filter.key, event.target.value);
    setValidatedParam(PLOT_ID, null);
  };

  return (
    <Radio.Group
      key={value}
      size="lg"
      label={
        <Text size="lg" mb="8px">
          {filter.label}
        </Text>
      }
      value={value}
    >
      {filter?.options?.map((option) => (
        <Radio
          key={option.value}
          variant="outline"
          value={option.value}
          label={option.label}
          checked={validatedParams[filter.key] === option.value}
          onChange={handleFilterChange}
        />
      ))}
    </Radio.Group>
  );
};

export default RadioFilter;
